<div class="container">
  <table
    *ngIf="!data.timeSeries?.isGrouped; else groupedTable"
    mat-table
    matSort
    [dataSource]="data.rows"
    (matSortChange)="sortChanged.emit($event)"
    class="table-container"
    cdkDropList
    cdkDropListOrientation="horizontal"
    (cdkDropListDropped)="dropColumns($event)"
  >
    <ng-container matColumnDef="name">
      <th mat-header-cell mat-sort-header="title" *matHeaderCellDef>Name</th>
      <td mat-cell *matCellDef="let row">{{ getLabel(row.name) }}</td>
    </ng-container>

    <ng-container *ngFor="let column of selectedFields" [matColumnDef]="column.name">
      <th
        mat-header-cell
        mat-sort-header
        *matHeaderCellDef
        [disabled]="!column.meta?.sorting"
        cdkDrag
        cdkDragBoundary=".table-container"
        cdkDropList
        cdkDragLockAxis="x"
      >
        <div class="drag-handle">
          <mat-icon [svgIcon]="'drag_indicator'"></mat-icon>
        </div>
        {{ getHeaderLabel(column) }}
      </th>
      <td mat-cell *matCellDef="let row">
        @if (getFieldDef(column.related_to_type ? column.name : row.name).meta?.value_hidden) {
          <span class="hidden-field"> REDACTED </span>
        } @else {
          {{
            column.name === 'id'
              ? row[column.name] || row.parentId
              : (row[column.name]
                | readableField: row : getFieldDef(column.related_to_type ? column.name : row.name) : options
                | zeroToNullPipe: shouldReplaceZeros)
          }}
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="dealGroup">
      <td *matCellDef="let group" [attr.colspan]="columns.length">
        <a [routerLink]="['/projects', group.pipeline_id, group.id, 'details', 'overview']">
          {{ group.name }}
        </a>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: columns" [class.total-row]="isTotalRow(row)"></tr>
    <tr mat-row *matRowDef="let row; columns: ['dealGroup']; when: isGroup" class="deal-group"></tr>
  </table>
  <ng-template #groupedTable>
    <table
      mat-table
      matSort
      [dataSource]="data.rows"
      (matSortChange)="sortChanged.emit($event)"
      class="table-container"
      cdkDropList
      cdkDropListOrientation="horizontal"
      (cdkDropListDropped)="dropColumns($event)"
    >
      <ng-container *ngFor="let column of columns" [matColumnDef]="column.name" [sticky]="shouldStickColumn(column)">
        <th
          mat-header-cell
          mat-sort-header
          *matHeaderCellDef
          [disabled]="!column.meta?.sorting"
          cdkDrag
          [cdkDragDisabled]="!canDrag(column)"
          cdkDragBoundary=".table-container"
          cdkDropList
          cdkDragLockAxis="x"
        >
          <div class="drag-handle" *ngIf="canDrag(column)">
            <mat-icon [svgIcon]="'drag_indicator'"></mat-icon>
          </div>
          {{ getHeaderLabel(column) }}
        </th>
        <td mat-cell *matCellDef="let row">
          <ng-container *ngIf="column.type || column.name === 'time_series_field'; else timeSerieDataCell">
            <span *ngIf="column.name === 'title'" [matTooltip]="row[column.name]" tooltipIfEllipsis>
              <a [routerLink]="['/projects', row.pipeline_id?.id, row?.id, 'details', 'overview']">
                {{ getLabel(row[column.name]) }}
              </a>
            </span>
            <span
              *ngIf="column.name !== 'title'"
              [class.subtotal]="row[column.name] === 'Subtotal'"
              [matTooltip]="row[column.name]"
              tooltipIfEllipsis
            >
              <ng-container *ngIf="row[column.name] === 'Subtotal'; else notSubtotal">Subtotal</ng-container>
              <ng-template #notSubtotal>
                <ng-container *ngIf="row[column.name] === 'Total'; else notTotal">
                  <span [class.font-medium]="isGroupLabel(column.name)">Total</span>
                </ng-container>
                <ng-template #notTotal>
                  <ng-container *ngIf="getCellValue(column, row) as value">
                    <span [class.font-medium]="isGroupLabel(column.name)">{{
                      value | zeroToNullPipe: shouldReplaceZeros
                    }}</span>
                  </ng-container>
                </ng-template>
              </ng-template>
            </span>
          </ng-container>
          <ng-template #timeSerieDataCell>
            <span [matTooltip]="row[column.name]" tooltipIfEllipsis [class.subtotal]="row[column.name] === 'Subtotal'">
              {{
                (row[column.name]?.label
                  ? getLabel(row[column.name])
                  : (row[column.name] | readableField: row : getFieldDef(row.fieldDefName) : options) ||
                    row[column.name]
                ) | zeroToNullPipe: shouldReplaceZeros
              }}
            </span>
          </ng-template>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayColumns; sticky: true"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayColumns"
        [class.deal-group]="isGroupRow(row)"
        [class.subtotal-row]="isSubTotalRow(row)"
        [class.total-row]="isTotalRow(row)"
      ></tr>
    </table>
  </ng-template>
</div>
